module.exports = __webpack_public_path__ + "static/media/nynorsk-dyslexia-confimation.a86addc8.jpg";